module.exports = __webpack_public_path__ + "static/media/OFF-on.988df8a2.svg";